/* istanbul ignore file */

import { closestCenter, DndContext, PointerSensor, useSensor, useSensors } from '@dnd-kit/core'
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'

import SortableShippingMethod from './SortableShippingMethod'

const SortableShippingMethodList = ({
  shippingMethods,
  regions,
  onChangeEnabled,
  onDelete,
  onEdit,
  onDuplicate,
  isEditable,
  dragging,
  onSortEnd,
  onSortStart,
}) => {
  const sensors = useSensors(useSensor(PointerSensor))
  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={onSortEnd} onDragStart={onSortStart}>
      <SortableContext items={shippingMethods} strategy={verticalListSortingStrategy}>
        <div>
          {shippingMethods.map((shippingMethod, index) => (
            <SortableShippingMethod
              key={shippingMethod?.id}
              data={shippingMethod}
              onEdit={onEdit}
              onDelete={onDelete}
              onDuplicate={onDuplicate}
              onChangeEnabled={onChangeEnabled}
              regions={regions}
              index={index}
              position={index}
              isEditable={isEditable}
              dragging={dragging}
            />
          ))}
        </div>
      </SortableContext>
    </DndContext>
  )
}

export default SortableShippingMethodList
